import React, { useEffect, useMemo, useRef } from "react";
import { JobField } from "../../graphql/generated/graphql";
import { jobFieldTypes } from "../../options";

interface FieldComponentProps {
  fieldKeys: JobField[];
  setFieldValue: (field: string, value: any) => void;
}

const FieldComponent: React.FC<FieldComponentProps> = ({
  fieldKeys,
  setFieldValue,
}) => {
  const prevFieldsRef = useRef<any[]>([]);

  const formattedFields = useMemo(
    () =>
      fieldKeys.map((key, index) => ({
        type: key,
        position: index + 1,
        required: true,
      })),
    [fieldKeys]
  );

  useEffect(() => {
    if (
      JSON.stringify(prevFieldsRef.current) !== JSON.stringify(formattedFields)
    ) {
      setFieldValue("fields.create", formattedFields);
      prevFieldsRef.current = formattedFields;
    }
  }, [formattedFields, setFieldValue]);

  return (
    <div className="border shadow m-2 p-2 bg-slate-50 rounded-lg">
      <h2 className="font-medium text-lg my-2">فیلدهای ورودی</h2>
      {fieldKeys.length === 0 ? (
        <p className="text-gray-500">هیچ فیلدی انتخاب نشده است.</p>
      ) : (
        fieldKeys.map((key, index) => {
          const field = jobFieldTypes[key];
          return field ? (
            <div
              key={`${key}-${index}`}
              className="flex mx-1 my-1 items-center"
            >
              {field.Icon && (
                <field.Icon
                  className="w-6 h-6 my-0.5"
                  aria-label={field.title}
                />
              )}
              <div className="mx-2 text-slate-700">{field.title}</div>
            </div>
          ) : (
            <div key={`${key}-${index}`} className="text-red-500">
              خطا در دریافت اطلاعات: {key}
            </div>
          );
        })
      )}
    </div>
  );
};

export default FieldComponent;
